import { type ReactNode } from "react";

import { Box, SxProps, Theme } from "@mui/material";

import { getSxPosition } from "@/src/components/atoms/OverlayContent/functions";
import { OverlayContentPosition } from "@/src/components/atoms/OverlayContent/types";

interface OverlayContentProps {
  children: ReactNode;
  position?: OverlayContentPosition;
  padding?: string | number;
  sx?: SxProps<Theme>;
}

const OverlayContent = (props: OverlayContentProps) => {
  const { children, position = "centerCenter", padding, sx } = props;
  const sxPosition = getSxPosition(position, padding);

  return (
    <Box
      sx={[
        {
          zIndex: 6,
          position: "absolute"
        },
        sxPosition,
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {children}
    </Box>
  );
};

export default OverlayContent;
